import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import {
  IonContent,
  IonImg,
  useIonViewDidEnter,
  useIonViewWillLeave
} from '@ionic/react'
import { appBasePath } from '../../config/app'
import { NewsSwipper } from '../../components/common/NewsSwipper'
import { radioSections } from '../../config/radioCategories'
import { setRootMetaTags } from '../../services/metatags'
import { setView } from '../../services/analytics'
import { setPixelView } from '../../services/fbPixel'

import './styles.scss'

const NotFound = props => {
  const [isVisible, setIsVisible] = useState(false)
  const contentRef = useRef()

  useIonViewDidEnter(() => {
    setIsVisible(true)
    setRootMetaTags({
      title: 'Yok Radio - ¡Ups! Algo ha ido mal - Contenido no encontrado'
    })
    setView(window.location.pathname)
    setPixelView()
  })

  useIonViewWillLeave(() => {
    setIsVisible(false)
  })

  if (isVisible === false) return null

  return (
    <IonContent
      fullscreen
      ref={contentRef}
      className='not-found page-wrapper'
    >
      <section className='notification'>
        <h1>
          ¡Ups! Algo ha ido mal
          <span role='img' aria-label='emoji sorprendido'> &#128551;</span>
        </h1>
        <IonImg
          src={`${appBasePath}/assets/images/notFound.png`}
          alt=''
        />
        <p>
          Parece que lo que buscas se ha movido de lugar o se perdió
          <span role='img' aria-label='emoji sonrisa de pena'> &#128556;</span>
        </p>
      </section>

      <section className='navigation'>
        <h2>
          Puedes hecharle un ojo a alguno de estos enlaces
          <span role='img' aria-label='emoji pensativo'> &#129300;</span>
        </h2>
        <div className='links'>
          <Link to='/' aria-label='Ir al inico'>Home</Link>
          <Link to='/news/1' aria-label='Ir a listado de news'>News</Link>
          <Link to='/podcast/explorar' aria-label='Explora todos los Podcast de Yok Radio'>Podcast</Link>
          {radioSections &&
            radioSections.radio.categories.detail.map((category) => (
              <Link
                key={category.id_category}
                to={`/${category.category_alias}/explorar`}
                aria-label={`Ver todos los programas de ${category.category}`}
              >
                {category.category}
              </Link>
            ))}
        </div>
      </section>

      <h2
        className='read-news'
      >
        Tambien puedes leer alguna de estas
        <span role='img' aria-label='emoji anteojo de un ojo'> &#129488;</span>
      </h2>
      <NewsSwipper />
    </IonContent>
  )
}

export default NotFound
